import { makeAsyncActionCreators } from '../../helpers';
import { QuestionnairesActionTypes } from '../types';

const fetchQuestionnaireByCustomerId = makeAsyncActionCreators(
  QuestionnairesActionTypes.fetchQuestionnaireByCustomerId,
  ['userId'],
  ['questionnaire', 'users'],
  ['error'],
);

const updateQuestionnaireByCustomer = makeAsyncActionCreators(
  QuestionnairesActionTypes.updateQuestionnaireByCustomer,
  [
    'questionnaireId',
    'customerId',
    'questionnaireSections',
    'shouldSubmit',
    'customerIsStartingQuestionnaire',
  ],
  ['questionnaire'],
  ['error'],
);

const getQuestionnaireByProjectId = makeAsyncActionCreators(
  QuestionnairesActionTypes.getQuestionnaireByProjectId,
  ['projectId'],
  ['questionnaire'],
  ['error'],
);

const createQuestionnaire = makeAsyncActionCreators(
  QuestionnairesActionTypes.createQuestionnaire,
  ['projectId', 'questionnaire'],
  ['questionnaire'],
  ['error'],
);

export default {
  fetchQuestionnaireByCustomerId,
  updateQuestionnaireByCustomer,
  getQuestionnaireByProjectId,
  createQuestionnaire,
};
